var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "#FCEA2B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.658 10.2409C11.6897 8.54818 9.53245 7.96098 7.83975 8.92938C6.14705 9.89778 5.55985 12.055 6.52825 13.7477C6.68345 14.0191 6.87405 14.2686 7.09495 14.4897L18.6273 29.5895L21.3156 32.9773L13.425 22.6459C12.4567 20.9532 10.2994 20.366 8.60675 21.3344C6.91405 22.3028 6.32685 24.46 7.29525 26.1527C7.45045 26.4241 7.64105 26.6736 7.86195 26.8948L15.7525 37.226L22.0232 45.125C27.4902 51.3981 36.5379 51.0556 42.8095 45.59C46.414 42.4216 48.7321 38.0418 49.3249 33.2795C49.7107 29.0469 50.1319 17.9785 50.1319 17.9785C49.9493 15.3777 46.9966 13.4551 46.6161 14.7983L41.7222 24.5558L38.3565 20.3334L41.7222 24.5558L38.3565 20.3334L24.8914 3.12478C23.9231 1.43208 21.7658 0.84488 20.0731 1.81328C18.3804 2.78168 17.7932 4.93888 18.7616 6.63158C18.9168 6.90298 19.1074 7.15248 19.3283 7.37358L23.5771 12.9367L30.0005 21.4167L16.5815 3.73658C15.6132 2.04388 13.4559 1.45668 11.7632 2.42508C10.0705 3.39348 9.48334 5.55068 10.4516 7.24338C10.6068 7.51478 10.7974 7.76428 11.0183 7.98548L25.6899 27",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67285 33.8719C5.67285 36.4382 7.41985 38.5147 9.57875 38.5147",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06152 33.4369C1.06152 39.0328 4.87092 43.561 9.57862 43.561",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2623 12.2377C39.2623 9.67141 37.5153 7.59491 35.3564 7.59491",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8735 12.6727C43.8735 7.07678 40.0641 2.54858 35.3564 2.54858",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.eee4a1b591772ff9b6d7d46c41dedda6.svg";
export { ForwardRef as ReactComponent };